"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gstMayApply = exports.isTierTypeSubjectToGST = exports.accountHasGST = exports.GST_RATE_PERCENT = void 0;
var lodash_1 = require("lodash");
var TierType_1 = __importDefault(require("./types/TierType"));
exports.GST_RATE_PERCENT = 15;
/**
 * Returns true if GST is enabled for this account
 */
exports.accountHasGST = function (account) {
    return Boolean(lodash_1.get(account, 'settings.GST') ||
        lodash_1.get(account, 'parent.settings.GST') ||
        lodash_1.get(account, 'parentCollective.settings.GST'));
};
/**
 * Returns true if the given tier type can be subject to VAT
 */
exports.isTierTypeSubjectToGST = function (tierType) {
    var taxedTiersTypes = [TierType_1.default.SUPPORT, TierType_1.default.SERVICE, TierType_1.default.PRODUCT, TierType_1.default.TICKET];
    return taxedTiersTypes.includes(tierType);
};
/**
 * Returns true if GST may apply.
 *
 * @param tierType - the tier type (eg. SUPPORT, TICKET...)
 * @param originCOuntry - two letters country where GST is applied
 */
exports.gstMayApply = function (tierType) {
    return exports.isTierTypeSubjectToGST(tierType);
};
//# sourceMappingURL=gst.js.map